<script>
import ToAdmin from '@/components/ToAdmin.vue'
import FormNoSave from '@/components/Form/FormNoSave.vue'
import message from '@/helpers/message'
import config from "@/helpers/config"

export default {
    components: { ToAdmin, FormNoSave },
    created() {
        if(!this.isAppearanceAdmin)
        {
            this.$router.push('/login');
        }

        this.getAppearence();
        this.getCustomer();
    },
    data() {
        return {
            appearence: null,
            customer: null,
            isSaving: false,
            savedBackgroundImageId: null,
            originalAppearenceJson: null,
            originalCustomerJson: null,
            appColorOptions: [
                { name: 'Jamii-grön', value: '#A3BDA4' },
                { name: 'Aubergine', value: '#5B1B67' },
                { name: 'Clementin', value: '#FD8707' },
                { name: 'Banangul', value: '#FFD95A' },
                { name: 'Jade', value: '#17815D' },
                { name: 'Lagun', value: '#1676A7' },
                { name: 'Barbapappa', value: '#F89AC2' },
                { name: 'Grå', value: '#D8D8D8' },
            ]
        }
    },
    methods:
    {
        normalizeAppColor(colorValue) {
            return /^#([0-9A-F]{3}){1,2}$/i.test(colorValue) ? colorValue : '#5B1B67';
        },
        getAppearence() {
            var self = this;
            this.$communicator.get('app-appearence/')
                .then(function(data)
                {
                    data.app_color = self.normalizeAppColor(data.app_color);
                    self.appearence = { ...data };
                    self.originalAppearenceJson = JSON.stringify(self.appearence);
                    self.$store.commit('setEntity', { entityName: 'appearence', entity: data });
                })
                .fail(function(error) {
                    self.$apiErrorhandler.handleErrors(error, self.$route.fullPath)
                });
        },
        getCustomer() {
            var self = this;
            this.$communicator.get('customers/')
                .then(function(data)
                {
                    self.customer = { ...data };
                    self.savedBackgroundImageId = data.background_image_id;
                    self.originalCustomerJson = JSON.stringify(self.customer);
                })
                .fail(function(error) {
                    self.$apiErrorhandler.handleErrors(error, self.$route.fullPath)
                });
        },
        save() {
            if(this.appearence == null || this.customer == null) { return; }

            message.removeMessage();
            this.isSaving = true;
            this.appearence.app_color = this.normalizeAppColor(this.appearence.app_color);

            var self = this;
            this.$communicator.post('app-appearence/', this.appearence)
                .then(function(data)
                {
                    data.app_color = self.normalizeAppColor(data.app_color);
                    self.appearence = { ...data };
                    self.$store.commit('setEntity', { entityName: 'appearence', entity: data });
                    self.saveBackgroundImage();
                })
                .fail(function(error) {
                    self.$apiErrorhandler.handleErrors(error, self.$route.fullPath)
                    self.isSaving = false;
                });
        },
        saveBackgroundImage() {
            if(this.customer.background_image_id == this.savedBackgroundImageId)
            {
                this.finishSave();
                return;
            }

            if(this.customer.background_image_id == null)
            {
                this.removeBackgroundImage();
                return;
            }

            var selectedImage = this.images.find(x => x.id == this.customer.background_image_id);
            if(selectedImage == null)
            {
                this.finishSave();
                return;
            }

            var self = this;
            this.$communicator.post('images/set-as-background-image/', selectedImage)
                .then(function(data)
                {
                    self.applySavedCustomer(data);
                    self.finishSave();
                })
                .fail(function(error) {
                    self.$apiErrorhandler.handleErrors(error, self.$route.fullPath)
                    self.isSaving = false;
                });
        },
        removeBackgroundImage() {
            var self = this;
            this.$communicator.post('images/remove-background-image/')
                .then(function(data)
                {
                    self.applySavedCustomer(data);
                    document.body.style.removeProperty('background-image');
                    localStorage.removeItem("samfallifyBgImg");
                    self.finishSave();
                })
                .fail(function(error) {
                    self.$apiErrorhandler.handleErrors(error, self.$route.fullPath)
                    self.isSaving = false;
                });
        },
        applySavedCustomer(customer) {
            this.customer = { ...customer };
            this.savedBackgroundImageId = customer.background_image_id;
            this.originalCustomerJson = JSON.stringify(this.customer);
            this.$store.commit('setEntity', { entityName: 'customer', entity: customer });

            if(customer.background_image_name != null)
            {
                var backgroundUrl = this.getCustomerBackgroundUrl(customer);
                $("body").css("background-image", backgroundUrl);
                localStorage.setItem("samfallifyBgImg", backgroundUrl);
            }
        },
        getCustomerBackgroundUrl(customer) {
            var imageUrl = 'url("' + this.url + 'uploads/' + customer.id + '/images/' + customer.background_image_name + '")';
            return 'linear-gradient(to right, rgba(0,0,0, 0.38) 0%, rgba(0,0,0, 0.10) 24%, rgba(0,0,0, 0) 40%, rgba(0,0,0, 0) 100%), linear-gradient(to bottom, rgba(0,0,0, 0.2), rgba(0,0,0, 0.5)), ' + imageUrl;
        },
        finishSave() {
            this.isSaving = false;
            this.originalAppearenceJson = JSON.stringify(this.appearence);
            this.originalCustomerJson = JSON.stringify(this.customer);
            message.setSuccessMessage('Toppen! Utseendet är nu sparat.');
        },
        resetChanges() {
            message.removeMessage();
            this.getAppearence();
            this.getCustomer();
        },
        setAppColor(colorValue) {
            if(this.appearence == null) { return; }

            this.appearence.app_color = colorValue;
        },
        useDefaultBackground() {
            if(this.customer == null) { return; }

            this.customer.background_image_id = null;
        },
        isSelectedColor(colorValue) {
            if(this.appearence == null || this.appearence.app_color == null) { return false; }

            return this.appearence.app_color.toLowerCase() == colorValue.toLowerCase();
        },
        getSwatchStyle(colorValue) {
            return {
                background: this.getGradientBackground(colorValue)
            };
        },
        getOptionStyle(colorValue) {
            return {
                borderColor: this.isSelectedColor(colorValue) ? '#2f6db5' : '#cfcfcf',
                boxShadow: this.isSelectedColor(colorValue) ? '0 0 0 1px #2f6db5 inset' : 'none'
            };
        },
        getPreviewStyle() {
            var appColor = this.appearence != null ? this.normalizeAppColor(this.appearence.app_color) : '#5B1B67';
            return {
                background: this.getGradientBackground(appColor),
                color: this.getContrastColor(appColor)
            };
        },
        getGradientBackground(hexColor) {
            var baseColor = this.normalizeAppColor(hexColor);
            return 'linear-gradient(135deg, ' + this.adjustHexColor(baseColor, 10) + ' 0%, ' + baseColor + ' 45%, ' + this.adjustHexColor(baseColor, -8) + ' 100%)';
        },
        adjustHexColor(hexColor, amount) {
            var hex = this.normalizeAppColor(hexColor).replace('#', '');
            var rgb = [
                parseInt(hex.substring(0, 2), 16),
                parseInt(hex.substring(2, 4), 16),
                parseInt(hex.substring(4, 6), 16)
            ];

            var adjustedHex = rgb.map(function(channel) {
                var nextValue = Math.max(0, Math.min(255, channel + Math.round((255 * amount) / 100)));
                return nextValue.toString(16).padStart(2, '0');
            }).join('');

            return '#' + adjustedHex.toUpperCase();
        },
        getContrastColor(hexColor) {
            if(hexColor == null || !/^#([0-9A-F]{3}){1,2}$/i.test(hexColor)) {
                return '#111111';
            }

            var hex = hexColor.replace('#', '');
            if(hex.length == 3) {
                hex = hex.split('').map(function(char) { return char + char; }).join('');
            }

            var r = parseInt(hex.substring(0, 2), 16);
            var g = parseInt(hex.substring(2, 4), 16);
            var b = parseInt(hex.substring(4, 6), 16);
            var brightness = (r * 299 + g * 587 + b * 114) / 1000;

            return brightness > 160 ? '#111111' : '#ffffff';
        }
    },
    computed:
    {
        isAppearanceAdmin()
        {
            if(this.user == null || this.user.user_level == null) { return false; }

            return this.user.user_level == 'SamfallifyCrew' || this.user.user_level.indexOf('Redakt') === 0;
        },
        logoForm() {
            return [
                { sections: [
                    { sectionName: 'Välj logga', classes: "g-100", inputs: [
                        { type: 'image', prop: 'logo_image_id', title: 'Klicka på den bild du vill använda som logga', classes: "g-100" },
                    ]},
                ],
                    backgroundColor: this.$colors.form.backgroundColor,
                    borderColor: this.$colors.form.borderColor
                }
            ];
        },
        backgroundForm() {
            return [
                { sections: [
                    { sectionName: 'Välj bakgrundsbild', classes: "g-100", inputs: [
                        { type: 'image', prop: 'background_image_id', title: 'Klicka på den bild du vill använda som bakgrund', classes: "g-100" },
                    ]},
                ],
                    backgroundColor: this.$colors.form.backgroundColor,
                    borderColor: this.$colors.form.borderColor
                }
            ];
        },
        images()
        {
            return this.$store.state.images != null ? this.$store.state.images : [];
        },
        url()
        {
            return config.urlToServer;
        },
        user()
        {
            return this.$store.state.user;
        },
        hasChanges()
        {
            if(this.appearence == null || this.customer == null || this.originalAppearenceJson == null || this.originalCustomerJson == null)
            {
                return false;
            }

            return JSON.stringify(this.appearence) !== this.originalAppearenceJson ||
                JSON.stringify(this.customer) !== this.originalCustomerJson;
        }
    }
}
</script>

<template>
    <div v-fade-in>
        <main class="opacity-admin-bg overflow-auto position-relative">
            <ToAdmin :section="'Utseende'"></ToAdmin>
            <h2>Utseende</h2>
            <div class="AdminAppearance-intro">
                Här kan ni anpassa ert visuella uttryck.
            </div>
            <div class="margin-top-15 overflow-auto" v-if="appearence != null && customer != null">
                <div class="g-50 float-left">
                    <fieldset class="AdminAppearance-fieldset" :style="{ 'background-color': this.$colors.form.backgroundColor, 'border-color': this.$colors.form.borderColor }">
                        <legend>Färgschema</legend>
                        <p class="AdminAppearance-help">
                        Välj ett färgschema
                        </p>
                        <div class="AdminAppearance-colors">
                            <button
                                v-for="colorOption in appColorOptions"
                                :key="colorOption.value"
                                type="button"
                                class="AdminAppearance-color-option"
                                :class="{ 'AdminAppearance-color-option-selected': isSelectedColor(colorOption.value) }"
                                :style="getOptionStyle(colorOption.value)"
                                @click="setAppColor(colorOption.value)"
                            >
                                <span class="AdminAppearance-color-swatch" :style="getSwatchStyle(colorOption.value)"></span>
                                <span class="AdminAppearance-color-name">{{ colorOption.name }}</span>
                            </button>
                        </div>
                        <div class="AdminAppearance-custom-color">
                            <label for="app-color-hex">Välj din egen färg</label>
                            <div class="AdminAppearance-custom-color-controls">
                                <input
                                    id="app-color-picker"
                                    v-model="appearence.app_color"
                                    type="color"
                                    class="AdminAppearance-native-picker"
                                >
                                <input
                                    id="app-color-hex"
                                    v-model="appearence.app_color"
                                    type="text"
                                    class="AdminAppearance-hex-input"
                                    placeholder="#5B1B67"
                                >
                            </div>
                        </div>
                        <div class="AdminAppearance-preview" :style="getPreviewStyle()">
                            <div class="AdminAppearance-preview-title">Förhandsvisning</div>
                            <div class="AdminAppearance-preview-chip">Meny</div>
                        </div>
                    </fieldset>
                </div>
                <div class="g-50 float-left">
                    <FormNoSave :form="logoForm" :item="appearence" :isEditing="true" :hideMandatoryInformation="true"></FormNoSave>
                </div>
                <div class="g-50 float-left">
                    <FormNoSave :form="backgroundForm" :item="customer" :isEditing="true" :hideMandatoryInformation="true"></FormNoSave>
                    <div class="AdminAppearance-background-actions">
                        <button class="btn btn-gray" @click="useDefaultBackground" :disabled="customer.background_image_id == null">Använd standardbakgrund</button>
                    </div>
                </div>
            </div>
        </main>
    </div>
    <button class="btn Admin-save-btn" v-if="hasChanges" @click="save" :disabled="isSaving" v-fade-in>Spara ändringarna</button>
</template>

<style scoped>
.AdminAppearance-fieldset
{
    border: 1px solid #ddd;
    margin: 5px;
    margin-bottom: 15px;
    padding: 4px 15px 15px 15px;
    text-align: left;
}

legend
{
    font-weight: 600;
    font-size: 13px;
    text-align: left;
    text-transform: uppercase;
}

.AdminAppearance-help
{
    margin: 10px 0px 16px 0px;
    line-height: 22px;
}

.AdminAppearance-colors
{
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
}

.AdminAppearance-color-option
{
    align-items: center;
    background-color: #f8f8f8;
    border: 1px solid #cfcfcf;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    gap: 12px;
    min-height: 58px;
    padding: 12px 14px;
    text-align: left;
    width: 100%;
}

.AdminAppearance-color-option-selected
{
    background-color: #f4f8ff;
}

.AdminAppearance-color-swatch
{
    border-radius: 999px;
    display: inline-block;
    flex: 0 0 32px;
    height: 32px;
    width: 32px;
}

.AdminAppearance-color-name
{
    color: #222;
    font-size: 15px;
    font-weight: 600;
}

.AdminAppearance-custom-color
{
    margin-top: 18px;
}

.AdminAppearance-custom-color label
{
    display: block;
    margin-bottom: 6px;
}

.AdminAppearance-custom-color-controls
{
    align-items: center;
    display: flex;
    gap: 10px;
}

.AdminAppearance-native-picker
{
    background: white;
    border: 1px solid #ccc;
    border-radius: 8px;
    height: 44px;
    padding: 4px;
    width: 60px;
}

.AdminAppearance-hex-input
{
    margin: 0px;
    width: 180px;
}

.AdminAppearance-preview
{
    border-radius: 8px;
    margin-top: 18px;
    min-height: 110px;
    padding: 18px;
}

.AdminAppearance-preview-title
{
    font-size: 22px;
    font-weight: bold;
}

.AdminAppearance-preview-chip
{
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    display: inline-block;
    font-size: 14px;
    font-weight: bold;
    margin-top: 16px;
    padding: 8px 14px;
}

.AdminAppearance-background-actions
{
    margin: 0px 5px 15px 5px;
}

.Admin-save-btn
{
    padding: 15px 0px;
    background-color: #58d64d !important;
    color: white;
    position: fixed;
    bottom: 0px;
    right: 0px;
    left: 0px;
    width: 100%;
    font-size: 16px;
}

@media (max-width: 900px)
{
    .AdminAppearance-colors
    {
        grid-template-columns: 1fr;
    }

    .AdminAppearance-custom-color-controls
    {
        align-items: flex-start;
        flex-direction: column;
    }

    .AdminAppearance-hex-input
    {
        width: 100%;
    }
}
</style>
